<ion-header #header>
  <ion-toolbar class="toolbar-header">
    <ion-buttons slot="start" [ngClass]="{'back-btn': match?.matchStatus === 'TBP' && isTeamSelected}">
      <ion-back-button defaultHref="individual"></ion-back-button>
    </ion-buttons>
    @if(canViewOnDevice && match){
        <ng-container *ngTemplateOutlet="segmentTmp"></ng-container>
    
        <ion-button
          class="ion-no-margin undo-btn  {{themeService?.isDarkMode ? 'dark' : 'light'}}"
          (click)="undo()"
          *ngIf="match?.matchStatus !== 'TBP'"
          slot="end"
        >
            <ion-icon name="arrow-undo-outline"></ion-icon>
        </ion-button>

        @if(match?.matchStatus === 'TBP' && isTeamSelected){
          <ion-button
            class="ion-no-margin undo-btn  {{themeService?.isDarkMode ? 'dark' : 'light'}}"
            (click)="undoTeamSelected()"
            slot="end"
          >
              <ion-icon name="arrow-undo-outline"></ion-icon>
          </ion-button>
        }

    }
    <ion-buttons slot="end">
      <app-network-status></app-network-status>
      <ion-button color="dark" class="nine-dots" (click)="moreOptions()">
        <ion-icon slot="start" name="apps"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  @if(canViewOnDevice){ 
    @if(match){
        <app-int-body (click)="showRealTimeScore()" [hidden]="selectedSegment !== 'scoring'" #teamScoreCard [match]="match" [tie]="tie"></app-int-body>
    }
}
</ion-header>
<ion-content>
  @if(canViewOnDevice){
    @if(match && selectedSegment === 'scoring'){
      <ng-container *ngTemplateOutlet="boltAndServerClock"></ng-container>
      <ng-container *ngTemplateOutlet="pointContainer"></ng-container>
      <ng-container *ngTemplateOutlet="teamPlayerCard"></ng-container>
    }

    @if (selectedSegment === 'points') {
        <app-score-list [isOfficial]="true" [match]="match"></app-score-list>
    }
} @else {
  <!-- START DESKTOP VIEW -->
    <ion-card>
        <ion-card-header>
            <ion-card-subtitle>{{'Invalid device' | translate}}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
            {{'The Intennse view is only available on phones and tablets. If you are viewing this from a phone or tablet please reach out to us.' | translate}}
            <ion-button [routerLink]="['/feedback']" routerLinkActive="router-link-active"  expand="block" fill="clear">
                {{'Contact us' | translate}}
            </ion-button>
        </ion-card-content>
    </ion-card>
    <!-- END DESKTOP VIEW -->
  }
</ion-content>

@if(canViewOnDevice && selectedSegment === 'scoring'){
    @if (match?.matchStatus === 'TBP' && (isTeamSelected || isServerSelected) && !isMatchStart) {
    <div class="match-btn">
      <ion-button
        color="primary"
        class="intennse-start-match-btn"
        expand="block"
        [disabled]="!isServerSelected"
         (click)="startMatch()"
      >
        <span>{{'Start Match' | translate}}</span>
      </ion-button>
    </div>
    } 

    @if(match?.matchStatus === 'IN_PROGRESS' && match?.score?.server?.sideNumber  && !isPointStarted){
        <div class="match-btn">
          <ion-button
            color="primary"
            class="intennse-start-match-btn"
            expand="block"
            (click)="startPoint()"
          >
            <span>{{'Start Point' | translate}}</span>
          </ion-button>
        </div>
    }
}
<!-- TEMPLATES -->
<ng-template #boltAndServerClock>
 @if(match){
  <div #clockBar
    class="watch-wrapper {{themeService?.isDarkMode ? 'dark' : 'light'}}"
    [hidden]="selectedSegment !== 'scoring'"
  >
    <ion-row
      *ngIf="match?.matchStatus === 'SUSPENDED'"
    >
      <ion-col size="12">
        <ion-button
          style="height: 100%"
          (click)="resumeSuspendedMatch()"
          expand="block"
          color="tertiary"
        >
          {{'Resume suspended match' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-grid 
        class="{{isBoltEnd ? 'slide-left': ''}}" 
        [fixed]="true" 
        *ngIf="!['SUSPENDED', 'COMPLETED'].includes(match?.matchStatus)"
        [style.height.px]="rowHeight * 1.5">
      <ion-row>
        @if(match?.matchStatus === 'TBP'){
          <ion-col class="serve-column {{themeService?.isDarkMode ? 'dark' : 'light'}}">
            <ion-label> {{'Warm Up' | translate}} </ion-label>
            <div>
              <app-stopwatch
                #warmUpClock
                [showButtons]="true"
                [match]="match"
                [clockInputValue]="getClock(clockName.WARM_UP) || getClock(clockName.DEFAULT)"
                [displayType]="'INTENNSE_VIEW'"
              ></app-stopwatch>
            </div>
            <div class="server-clock-icon" (click)="setClockIconClick(warmUpClock)">
              @if(warmUpClock?.clock()?.isPaused){
                  <ion-icon name="play-circle"></ion-icon>
              } @else {
                  <ion-icon name="pause-circle"></ion-icon>
              }
            </div>
            
          </ion-col>
          <ion-col class="bolt-column {{themeService?.isDarkMode ? 'dark' : 'light'}}">

          </ion-col>
        }
        <ion-col [style.display]="match?.matchStatus === 'IN_PROGRESS' ? 'flex' : 'none'" class="serve-column {{themeService?.isDarkMode ? 'dark' : 'light'}}">
          <ion-label> {{'Serve' | translate}} </ion-label>
          <div>
            <app-stopwatch
              #pointBreakClock
              [showButtons]="true"
              [match]="match"
              [clockInputValue]="getClock(clockName.POINT_BREAK)"
              [displayType]="'INTENNSE_VIEW'"
            ></app-stopwatch>
          </div>
          <div class="server-clock-icon" (click)="pointBreakClockIconClick()">
            @if(pointBreakClock?.clock()?.isPaused){
                <ion-icon name="play-circle"></ion-icon>
            } @else {
                <ion-icon name="pause-circle"></ion-icon>
            }
          </div>            
        </ion-col>

        <ion-col [style.display]="match?.matchStatus === 'IN_PROGRESS' ? 'flex' : 'none'" class="bolt-column {{themeService?.isDarkMode ? 'dark' : 'light'}}">
          <ion-label> {{'Bolt' | translate}} {{ match?.sets?.length || 1 }} </ion-label>
          <div class="stop-watck">
            <app-stopwatch
              #setTimeClock
              [showButtons]="false"
              [match]="match"
              [clockInputValue]="getClock(clockName.SET_TIME)"
              [displayType]="'INTENNSE_VIEW'"
              (boltClockEnd)="onBoltClockEnd()"
            ></app-stopwatch>
          </div>
          <div class="bolt-clock-icon" (click)="setTimeClockIconClick()">
            @if(setTimeClock?.clock()?.isPaused || isBoltEnd){
                <ion-icon name="play-circle"></ion-icon>
            } @else {
                <ion-icon name="pause-circle"></ion-icon>
            }
          </div>
        </ion-col>
        <div class="time-end" *ngIf="isBoltEnd" (click)="boltMatchEnd()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </div>
      </ion-row>
      <ion-icon class="clock-time-icon {{themeService?.isDarkMode ? 'dark' : 'light'}}" name="time"></ion-icon>
    </ion-grid>
  </div>
}
</ng-template>

<ng-template #segmentTmp>
  <ion-list class="centered-select">
    <ion-item>
      <ion-select 
        aria-label="View Mode" 
        interface="popover" 
        placeholder="{{'Select view' | translate}}" 
        [(ngModel)]="selectedSegment" 
        (ionChange)="segmentChanged($event)">
        
        <ion-select-option value="scoring">{{'Scoring' | translate}}</ion-select-option>
        <ion-select-option value="points">{{'Points' | translate}}</ion-select-option>

        <ion-icon slot="icon" name="caret-down-outline" ></ion-icon>
      </ion-select>
    </ion-item>
  </ion-list>
</ng-template>

<ng-template #teamPlayerCard>
  @if(match && match?.matchStatus === 'TBP' && isMatchStart && isTeamSelected) {
  <div class="team-card 1" [hidden]="selectedSegment !== 'scoring'">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col>
          @if(this.tie){
            <app-int-team-name
                [rowHeight]="rowHeight"
                [isReverse]="isReverse"
                [sideColors]="sideColors"
                [sideName]="isReverse ? 'side2' : 'side1'"
                [sideNumber]="isReverse ? 2 : 1"
                [tie]="tie"
            >
            </app-int-team-name>
          }
        </ion-col>
        <ion-col>
          @if(this.tie){
            <app-int-team-name
                [rowHeight]="rowHeight"
                [isReverse]="isReverse"
                [sideColors]="sideColors"
                [sideName]="isReverse ? 'side1' : 'side2'"
                [sideNumber]="isReverse ? 1 : 2"
                [tie]="tie"
            >
            </app-int-team-name>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  } 
  
  @if(match) {
    @if(!isPointStarted && (match?.matchStatus === 'IN_PROGRESS' || match?.matchStatus === 'TBP')){
        <div class="team-card 2" [hidden]="selectedSegment !== 'scoring'">
            <ion-grid [fixed]="true">
              <ion-row>
                <ion-col>
                  <div class="ion-text-center player-list">
                    <app-int-select-server
                      [teamName]="getTeam(isReverse ? 2 : 1)?.name"
                      [player]="isReverse ? teamSide2Players : teamSide1Players"
                      [color]="isReverse ? sideColors[1] : sideColors[0]"
                      [rowHeight]="rowHeight"
                      [match]="match"
                      [isReverse]="isReverse"
                      (serverSelected)="onServerSelected($event)"
                      [sideNumber]="isReverse ? 2 : 1"
                      [selectedTeam]="selectedTeamSide"
                      (teamSelected)="onTeamSelected($event)"
                      [hideSelectServingAndServer]="hideSelectServingAndServer"
                    ></app-int-select-server>
                  </div>
                </ion-col>
                <ion-col>
                  <div class="ion-text-center player-list  side-two">
                    <app-int-select-server
                      [teamName]="getTeam(isReverse ? 1 : 2)?.name"
                      [player]="isReverse ? teamSide1Players : teamSide2Players"
                      [color]="isReverse ? sideColors[0] : sideColors[1]"
                      [rowHeight]="rowHeight"
                      [match]="match"
                      [isReverse]="isReverse"
                      (serverSelected)="onServerSelected($event)"
                      [sideNumber]="isReverse ? 1 : 2"
                      [selectedTeam]="selectedTeamSide"
                      (teamSelected)="onTeamSelected($event)"
                      [hideSelectServingAndServer]="hideSelectServingAndServer"
                    ></app-int-select-server>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
        </div>
    }
    @if(match?.matchStatus === 'IN_PROGRESS' && isPointStarted && isServerChange ){
        <div class="team-card 3" [hidden]="selectedSegment !== 'scoring'">
            <ion-grid [fixed]="true">
              <ion-row>
                <ion-col>
                  <div class="ion-text-center player-list">
                    <app-int-select-server
                      [teamName]="getTeam(isReverse ? 2 : 1)?.name"
                      [player]="isReverse ? teamSide2Players : teamSide1Players"
                      [color]="isReverse ? sideColors[1] : sideColors[0]"
                      [rowHeight]="rowHeight"
                      [match]="match"
                      *ngIf="(serverWinningSide === 1 && !isReverse) || (serverWinningSide === 2 && isReverse)"
                      [serverWinningSide]="serverWinningSide"
                      (resetServerWinningSide)="resetServerWinningSide($event)"
                      [isReverse]="isReverse"
                      [hideSelectServingAndServer]="!hideSelectServingAndServer"
                    ></app-int-select-server>
                  </div>
                </ion-col>
                <ion-col>
                  <div class="ion-text-center player-list  side-two">
                    <app-int-select-server
                      [teamName]="getTeam(isReverse ? 1 : 2)?.name"
                      [player]="isReverse ? teamSide1Players : teamSide2Players"
                      [color]="isReverse ? sideColors[0] : sideColors[1]"
                      [rowHeight]="rowHeight"
                      [match]="match"
                      *ngIf="(serverWinningSide === 2 && !isReverse) || (serverWinningSide === 1 && isReverse)"
                      [serverWinningSide]="serverWinningSide"
                      (resetServerWinningSide)="resetServerWinningSide($event)"
                      [isReverse]="isReverse"
                      [hideSelectServingAndServer]="!hideSelectServingAndServer"
                    ></app-int-select-server>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
        </div>
    } 
  }
</ng-template>

<ng-template #pointContainer>
    @if(match?.matchStatus === 'IN_PROGRESS'){
        <div class="team-card 4" [hidden]="selectedSegment !== 'scoring'">
            <ion-grid [fixed]="false">
              <ion-row>
                <ion-col>
                  @if(this.tie){
                    <app-int-team-name
                        [rowHeight]="rowHeight"
                        [isReverse]="isReverse"
                        [sideColors]="sideColors"
                        [sideName]="isReverse ? 'side2' : 'side1'"
                        [sideNumber]="isReverse ? 2 : 1"
                        [tie]="tie"
                    >
                    </app-int-team-name>
                  }
                  <div class="ion-text-center player-list timeout">
                    <div class="ace-fault {{themeService?.isDarkMode ? 'dark' : 'light'}}"
                    [style.height.px]="rowHeight * 1">
                        <div>
                            <app-timeout 
                                [match]="match" 
                                [tie]="tie" 
                                [sideColors]="sideColors"
                                [isTimeoutClock]="isTimeoutClock"
                                [matchTimeout]="matchTimeout"
                                [sideName]="isReverse ? 'side2' : 'side1'"
                                [rowHeight]="rowHeight"
                                (timeoutEndEvent)="onTimeoutEnd()"
                                (timeoutStarted)="onTimeoutStarted($event)"
                                (timeoutUndo)="onTimeoutUndo($event)">
                            </app-timeout>
                        </div>
                        <div>
                            <app-substitution
                                [sideColors]="sideColors"
                                [sideName]="isReverse ? 'side2' : 'side1'"
                                [match]="match"
                                [tie]="tie" 
                                [rowHeight]="rowHeight">
                            </app-substitution>
                        </div>
                    </div>
                  </div>
                </ion-col>
                <ion-col>
                  @if(this.tie){
                    <app-int-team-name
                        [rowHeight]="rowHeight"
                        [isReverse]="isReverse"
                        [sideColors]="sideColors"
                        [sideName]="isReverse ? 'side1' : 'side2'"
                        [sideNumber]="isReverse ? 1 : 2"
                        [tie]="tie"
                    >
                    </app-int-team-name>
                  }
                  <div class="ion-text-center player-list timeout">
                    <div class="ace-fault {{themeService?.isDarkMode ? 'dark' : 'light'}}"
                    [style.height.px]="rowHeight * 1">
                        <div>
                            <app-timeout 
                                [match]="match" 
                                [tie]="tie" 
                                [sideColors]="sideColors"
                                [isTimeoutClock]="isTimeoutClock"
                                [matchTimeout]="matchTimeout"
                                [sideName]="isReverse ? 'side1' : 'side2'"
                                [rowHeight]="rowHeight"
                                (timeoutEndEvent)="onTimeoutEnd()"
                                (timeoutStarted)="onTimeoutStarted($event)"
                                (timeoutUndo)="onTimeoutUndo($event)">
                            </app-timeout>
                        </div>
                    <div>
                        <app-substitution
                            [sideColors]="sideColors"
                            [sideName]="isReverse ? 'side1' : 'side2'"
                            [match]="match"
                            [tie]="tie" 
                            [rowHeight]="rowHeight">
                        </app-substitution>
                    </div>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
        </div>
    }
    @if(match?.matchStatus === 'IN_PROGRESS' && isPointStarted && !isServerChange) {
        <div class="team-card 5" [hidden]="selectedSegment !== 'scoring'">
            <ion-grid [fixed]="false">
                <ion-row>
                <ion-col>
                    <div class="ion-text-center player-list">
                        <div class="ace-fault {{themeService?.isDarkMode ? 'dark' : 'light'}}" [style.height.px]="rowHeight * 1">
                          @if(isReverse){ @if(match.score?.server?.sideNumber == 2){
                          <ng-container *ngTemplateOutlet="ACEandFaultButtons"></ng-container>
                          } } @else{ @if(match.score?.server?.sideNumber == 1){
                          <ng-container *ngTemplateOutlet="ACEandFaultButtons"></ng-container>
                          } }
                        </div>
                        <app-int-point-container
                            [sideColors]="sideColors"
                            [sideName]="isReverse ? 'side2' : 'side1'"
                            [rowHeight]="tie ? rowHeight : rowHeight - 5"
                            [isReverse]="isReverse"
                            [match]="match"
                            (pointScored)="addPointScore($event.sideNumber, $event.points)"
                            [sideNumber]="isReverse ? 2 : 1">
                        </app-int-point-container>
                    </div>
                </ion-col>
                <ion-col>
                    <div class="ion-text-center player-list">
                        <div class="ace-fault {{themeService?.isDarkMode ? 'dark' : 'light'}}" [style.height.px]="rowHeight * 1">
                          @if(isReverse){ @if(match.score?.server?.sideNumber == 1){
                          <ng-container *ngTemplateOutlet="ACEandFaultButtons"></ng-container>
                          } } @else{ @if(match.score?.server?.sideNumber == 2){
                          <ng-container *ngTemplateOutlet="ACEandFaultButtons"></ng-container>
                          } }
                        </div>
                    <app-int-point-container
                        [sideColors]="sideColors"
                        [sideName]="isReverse ? 'side1' : 'side2'"
                        [rowHeight]="tie ? rowHeight : rowHeight - 5"
                        [isReverse]="isReverse"
                        [match]="match"
                        (pointScored)="addPointScore($event.sideNumber, $event.points)"
                        [sideNumber]="isReverse ? 1 : 2">
                    </app-int-point-container>
                    </div>
                </ion-col>
            </ion-row>
            </ion-grid>
        </div>
    }
</ng-template>

<ng-template #ACEandFaultButtons>
    <ion-button
      [disabled]="isCompleted() || isInterrupted()"
      class="ion-no-margin btn"
      [style.--background]="'#ffffff'"
      [style.border]="'2px solid ' + sideColors[match.score?.server?.sideNumber - 1]"
      (click)="ace()"
      translate
      [style.font-size.px]="rowHeight / 5"
    >
      {{'ACE' | translate}}
    </ion-button>
  
    <ion-button
      [disabled]="isCompleted() || isInterrupted()"
      class="ion-no-margin btn"
      [style.--background]="'#ffffff'"
      [style.border]="'2px solid ' + sideColors[match.score?.server?.sideNumber - 1]"
      (click)="fault('O')"
      translate
      [style.font-size.px]="rowHeight / 5"
    >
      {{'FAULT' | translate}}
    </ion-button>
</ng-template>


<!-- IMPOARTED COMPONENTS -->
@if (match) {
<app-tracker-board
  hidden
  [match]="match"
  #board
  [shotStatsBoard]="false"
  [intennseView]="true"
></app-tracker-board>
<app-tracker-bar
  hidden
  [match]="match"
  #trackerBar
  [isTracker]="isTracker"
  [isOwner]="isOwner"
  (stopTimedSet)="board.completeTimedSet()"
></app-tracker-bar>
<app-int-select-server
  hidden
  [teamName]="getTeam(isReverse ? 1 : 2)?.name"
  [player]="isReverse ? teamSide1Players : teamSide2Players"
  [color]="isReverse ? sideColors[0] : sideColors[1]"
  [rowHeight]="rowHeight"
  [match]="match"
  [isReverse]="isReverse"
  [htmlView]="true"
  #intSelectServer
></app-int-select-server>
}